import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import classes from './dropdown.scss';
import { itemHeight } from '../constants';
import DropdownItem from './DropdownItem';

class Dropdown extends Component {
  createItems() {
    const { selectedItemIndex, dispatch, handleClickItem } = this.props;
    return this.props.items.map((item, i) => {
      const dropdownItemProps = {
        key: i,
        item,
        index: i,
        selected: selectedItemIndex === i,
        dispatch,
        handleClickItem,
      };
      return <DropdownItem { ...dropdownItemProps } />;
    });
  }

  render() {
    const dropdownItems = this.createItems();
    const dropdownClasses = cx({
      [classes.itemList]: true,
      [classes.silverBottom]: this.props.items.length,
      [classes.hide]: !this.props.open,
    });
    const dropdownStyle = {
      maxHeight: `${itemHeight * this.props.numVisibleItems}px`,
    };
    const dropdownProps = {
      className: dropdownClasses,
      style: dropdownStyle,
      ref: 'dropdown',
    };
    return (
      <ul { ...dropdownProps } >{ dropdownItems }</ul>
    );
  }
}

Dropdown.propTypes = {
  items: PropTypes.array.isRequired,
  numVisibleItems: PropTypes.number.isRequired,
  direction: PropTypes.number,
  open: PropTypes.bool.isRequired,
  selectedItemIndex: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  handleClickItem: PropTypes.func.isRequired,
};

export default Dropdown;



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/components/Dropdown.js
 **/